import { injectable } from 'inversify';
import { Result } from '@Redux/type';
import { Nullable } from '@Models';

@injectable()
export class SyncAction {
  //  @inject(TYPES.Worker.CacheManager) private _cacheManager!: CacheManager;
  //  @inject(TYPES.Locale) private _locale!: Locale;

  public sendSyncEvent = (): Result<void> => async (dispatch, getState) => {
    console.log('Auto sync cache disable');
    //console.log('Start sync cache')
    //await this._cacheManager.syncCache({locale: this._locale.getlocale()});

    //toast.success('Cache Successfully updated!')
  };

  public async syncLocalCache({
    locale,
  }: {
    locale: Nullable<string>;
  }): Promise<void> {
    console.log('Auto sync cache disable');
    //console.log('Start sync cache')
    //await this._cacheManager.syncCache({locale: locale ?? this._locale.getlocale()});
  }
}
